import React from 'react'

const Event = () => <div style={{ textAlign: 'center', color: 'white' }}>
  <h1 className="runner">Event</h1>
</div>

export default Event
